<template>
  <div
    class="designer-question"
    :class="{'selected':question.$selected, 'open':open}"
  >
    <header>
      <button class="drag-handler">
        <i class="icon-drag_handle" />
      </button>
      <h2 @click="$emit('select', question)">
        <span class="index">{{ currentIndex }}</span>
        <span class="name">{{ name }}</span>
      </h2>
      <div class="controls">
        <span class="hover-controls">
          <button
            class="btn"
            @click="$emit('delete', index)"
          >
            <i class="icon-delete" />
          </button>
        </span>
        <span class="always-visible-controls">
          <button
            class="btn btn-toggle"
            @click="toggle"
          >
            <i
              v-if="open"
              class="icon-expand_less"
            />
            <i
              v-else
              class="icon-expand_more"
            />
          </button>
        </span>
      </div>
    </header>
    <main>
      <div
        v-if="question.description"
        class="description"
        v-html="question.description"
      />
      <div
        class="answers-wrapper"
        v-if="question.$answers.length"
      >
        <!-- VERDADERO / FALSO -->
        <el-switch
          v-model="question.$result"
          active-text="Sí"
          inactive-text="No"
          v-if="question.type==='true_or_false'"
        />
        <!-- OPCIÓN MÚLTIPLE -->
        <el-checkbox-group
          v-model="question.$result"
          v-if="question.type==='multiple'"
        >
          <div
            class="answer-item"
            v-for="(answer, $index) in question.$answers"
            :key="$index"
          >
            <el-checkbox :label="answer.name">
              {{ answer.name }}
            </el-checkbox>
          </div>
        </el-checkbox-group>

        <!-- OPCIÓN ÚNICA -->
        <div v-if="question.type==='unique'">
          <div
            v-for="answer in question.$answers"
            :key="answer.name"
            class="answer-item"
          >
            <el-radio
              v-model="question.$result"
              :label="answer.name"
            >
              {{ answer.name }}
            </el-radio>
          </div>
        </div>

        <!-- RANGO -->
        <div
          class="slider"
          v-if="question.type==='range_options'"
        >
          <vue-slider
            v-model="dummyValue"
            :data="onlyAnswers"
            v-bind="sliderConfig"
          />
        </div>

        <!-- RANGO NUMÉRICO -->
        <div
          class="slider"
          v-if="question.type==='range'"
        >
          <el-slider
            v-model="dummyValue"
            input-size="large"
            :max="100"
          />
        </div>
      </div>
    </main>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import VueSlider from 'vue-slider-component'

export default {
  name: 'DesignerQuestion',
  components: { VueSlider },
  props: {
    index: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    question: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: true,
      dummyValue: null,
      sliderConfig: {
        tooltip: 'always',
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        processStyle: {
          backgroundColor: '#999'
        },
        piecewiseStyle: {
          backgroundColor: '#ccc',
          visibility: 'visible',
          width: '12px',
          height: '12px'
        },
        piecewiseActiveStyle: {
          backgroundColor: '#999'
        },
        labelActiveStyle: {
          color: '#999'
        }
      }
    }
  },
  computed: {
    currentIndex () {
      let result = ''
      for (let i = 0; i < this.index.length; i++) {
        result += this.index[i] + 1 + '.'
      }
      return result.slice(0, -1)
    },
    name () {
      return this.question.name || 'Pregunta sin nombre'
    },
    onlyAnswers () {
      let answers = []

      for (let answer in this.question.$answers) {
        answers.push(this.question.$answers[answer].name)
      }
      return answers
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    update (e) {
      console.log(e.target.value)
      this.$emit('update:question', e.target.value)
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.designer-question {
  border: 1px solid #fff;
  background-color: #fff;
  margin: 10px 20px;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
  &:hover {
    .hover-controls {
      transition: all 0.3s ease-in-out;
      opacity: 1;
    }
  }
  &.open {
    main {
      max-height: 1000px;
      padding: 0 20px 0 20px;
    }
  }
  &.selected {
    border: 1px solid $color-ui-primary;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    h2 {
      .index {
        transition: all 0.3s ease-in-out;
        color: #fff;
        background-color: $color-ui-primary;
      }
    }
  }

  header {
    position: relative;
    overflow: hidden;
    .drag-handler {
      position: absolute;
      top: 0;
      left: 0;
      background-color: transparent;
      width: 55px;
      height: 55px;
      border: none;
      color: #dddddd;
      &:focus {
        outline: none;
      }
      &:hover {
        cursor: grab;
      }
      &:active {
        cursor: grabbing;
      }
      .icon-drag_handle {
        color: #dddddd;
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        font-size: 18px;
        line-height: 36px;
        user-select: none;
        border: 1px solid transparent;
        padding: 0.375rem 0.75rem;
      }
    }
    h2 {
      margin-top: 16px;
      margin-left: 55px;
      cursor: pointer;
      padding-right: 140px;
      display: block;
      @include font-primary(14px, regular);
      color: #444444;
      line-height: 26px;
      .index {
        @include font-primary(12px, bold);
        display: inline-block;
        height: 26px;
        padding: 0 5px;
        vertical-align: middle;
        line-height: 24px;
        border-radius: 2px;
        margin-right: 20px;
        float: left;
      }
    }
    .controls {
      position: absolute;
      top: 0;
      right: 0;
      .btn {
        margin-top: 7px;
        color: #999999;
        &:focus {
          box-shadow: none;
        }
      }
      .hover-controls {
        opacity: 1;
      }
    }
  }
  main {
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    max-height: 0;
    padding: 0 20px;
    .description {
      margin-left: 60px;
      padding-bottom: 20px;
    }
    .answers-wrapper {
      margin-left: 100px;
      padding-bottom: 20px;
      .answer-item {
        padding: 5px;
      }
    }
  }

  .btn {
    width: 40px;
    height: 40px;
    background-color: transparent;
    border-radius: 0;
    border: none;
    &:focus {
      outline: none;
    }
    &.btn-expand {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-question.vue